module.exports = __webpack_public_path__ + "img/Antarctica (the territory South of 60 deg S).5dfc433c.svg";